import cn from "classnames";

import { BaseButton } from "@/src/component/base/BaseButton";
import { ImgBgResponsive } from "@/src/component/base/ImgBgResponsive";
import { StyleHooks } from "@/src/hook";
import type { BrokerProfileType, StrapiCollectionType, StrapiComponentType } from "@/src/type";
import { LoadFromCDN } from "@/src/util";

import styles from "./ProfileBody.module.scss";

interface ProfileBodyProps {
  profile?: BrokerProfileType.BrokerProfile | null;
  isDesktop?: boolean;
  promo?: StrapiCollectionType.Promo | null;
  hasBrokerProfile: boolean;
}

function ProfileBody({ profile, promo, hasBrokerProfile }: ProfileBodyProps) {
  const profileBanner = promo?.promoControl?.[0] as StrapiComponentType.Object.ProfileBanner;
  const isMobile = StyleHooks.useBreakPointDown("md");
  const hasOptionalButton = profile?.optionalLink && profile?.optionalLinkLabel;

  if (!profile) {
    return <></>;
  }

  return (
    <div className={styles.body}>
      <div className={cn(styles.bodyTop, hasOptionalButton ? styles.twoButtons : undefined)}>
        {profile?.brokerageLogo?.data?.attributes?.url && (
          <>
            <div className={styles.brokerageLogo}>
              <ImgBgResponsive
                lazy="eager"
                imageUrl={LoadFromCDN.imageSizeAndQuality(profile?.brokerageLogo?.data?.attributes?.url, 100, 500)}
                className={styles.logoImg}
              />
            </div>
            <div className={styles.spacer}></div>
          </>
        )}
        <div className={styles.about}>
          <p className={styles.profileName}>About {profile.firstName}</p>
          <p className={styles.bio}>{profile.bio}</p>
        </div>
      </div>
      <div className={styles.buttons}>
        {profile.brokerageName && profile.brokerageWebsite && (
          <a
            href={profile.brokerageWebsite}
            className={styles.link}
          >
            <BaseButton
              fullWidth
              variant="contained"
              size={isMobile ? "medium" : "large"}
            >
              {!hasBrokerProfile ? profileBanner?.button1Text : profile.brokerageName}
            </BaseButton>
          </a>
        )}
        {profile.optionalLink && profile.optionalLinkLabel && (
          <a
            href={profile.optionalLink}
            className={styles.link}
          >
            <BaseButton
              fullWidth
              variant="outlined"
              size={isMobile ? "medium" : "large"}
            >
              {profile.optionalLinkLabel}
            </BaseButton>
          </a>
        )}
      </div>
    </div>
  );
}

export default ProfileBody;
